<template>
<div :class="{ 'bg-gradient-jwa': !bgTransparent }" class="navbar shadow py-1">
  <div class="">
    <div class="flex flex-row items-center container px-4 my-2">
      <a class="navbar-brand logo no-underline -mt-2" href="/">jwa.</a>
      <svg class="fill-current h-6 w-6 ml-auto text-white mt-2 cursor-pointer md:hidden"
        viewBox="0 0 20 20"
        @click="toggleNavbarExpanded"
        xmlns="http://www.w3.org/2000/svg"
      ><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
      </svg>
      <div class="navbar-items hidden md:flex md:flex-grow items-center">
        <ul class="pl-2">
          <li><a class="hover:text-grey-lighter" href="/#pricing">Pricing</a></li>
          <li><a href="docs">documentation</a></li>
          <li><a href="/#features">Features</a></li>
          <li><a href="help">Help</a></li>
        </ul>
        <div class="flex flex-grow justify-end">
          <template v-if="user.guest">
            <a class="btn btn-primary mx-2" href="/login">LOGIN</a>
            <a class="btn btn-primary mx-2" href="/register">SIGN UP</a>
          </template>
          <template v-if="!user.guest">
            <a class="no-underline text-white flex items-center hover:text-grey-light" href="/dashboard">
              <svg class="fill-current h-4 w-4 mx-2" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <title>Dashboard</title>
                <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"/>
              </svg>
              {{ user.full_name }} (#{{ user.customer_id }})
            </a>
          </template>
        </div>
      </div>
    </div>
    <div :class="{ hidden: !navbarExpanded}" class="navbar-items navbar-items-mobile border-t-2 border-blue px-r my-2 md:hidden">
      <ul class="px-0 text-center my-4">
        <li><a class="hover:text-grey-lighter" href="/#pricing">Pricing</a></li>
        <li><a href="/docs">documentation</a></li>
        <li><a href="/#features">Features</a></li>
        <li><a href="/help">Help</a></li>
      </ul>
        <template v-if="user.guest">
          <div class="flex justify-between">
            <a class="btn btn-primary flex-grow mx-2" href="/login">LOGIN</a>
            <a class="btn btn-primary flex-grow mx-2" href="/register">SIGN UP</a>
          </div>
        </template>
        <template v-if="!user.guest">
          <div class="flex justify-center">
            <a class="no-underline text-white flex items-center hover:text-blue-lightest" href="/dashboard">
              <svg class="fill-current h-4 w-4 mx-2" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <title>Dashboard</title>
                <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"/>
              </svg>
              {{ user.full_name }} (#{{ user.customer_id }})
            </a>
          </div>
        </template>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: ['props'],
  data () {
    return {
      user: this.props.user || this.guest(),
      navbarExpanded: false,
      bgTransparent: this.props.bgTransparent
    }
  },
  created () {
    console.log(this.props)
  },
  methods: {
    toggleNavbarExpanded () {
      this.navbarExpanded = !this.navbarExpanded
    },
    guest () {
      return {
        guest: true,
      }
    }
  }
}
</script>
<style scoped>
.logo {
  font-family: 'Arimo', sans-serif;
  font-size: 50px;
  color: #fff;
}

.nabvar {
  min-height: 60px;
}

.navbar-items li {
  display: inline-block;
  position: relative;
  list-style: none;
  color: #fff;
}

.navbar-items li a {
  text-transform: uppercase;
  position: relative;
  display: block;
  text-decoration: none;
  color: #fff;
  line-height: inherit;
  padding: 5px;
  font-size: 14px;
}

.navbar-items li a:hover {
  color: #24b5ff;
}

.navbar-items-mobile li a {
  padding: 10px;
}

</style>



// WEBPACK FOOTER //
// app/javascript/components/navbar.vue?0186f094